import main from './main'

export class teras extends main{

   constructor (args) {
      super(args)
      this.name = 'members.sip.it.tesoreria'
      this.version = '1.0.1'
      this.urlsite = (process.env.NODE_ENV != 'development') ? document.location.origin + '/tesoreria/' : ''
      this.page = {
         title: 'Home'
      }

      this.apiUrl = 'https://api-cs05.terasmm.it/201806/'
      this.mysql = {
         composer:'db',
         adapter:'teras-cs05',
         database:'sip_limmsy'
      }
   
      
      this.utente = {id:'',email:''}
      super.init()
      return this
   }

 
}
export default new teras
